/**
 * Generated by orval v8.23.0 🍺
 * Do not edit manually.
 * Arbi API
 * OpenAPI spec version: 1.0.0
 */

export interface SignatureContact {
  show_phone?: boolean;
  /** @maxLength 40 */
  phone?: string;
  show_email?: boolean;
  /** @maxLength 254 */
  email?: string;
}
